module.exports = __webpack_public_path__ + "static/img/icon-grzx.c676b13f.png";